var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ninety"},[_c('div',{staticClass:"ninety_left"},[_c('p',[_vm._v("北京八号地信息技术有限公司成立")]),_c('img',{attrs:{"src":require("../assets/images/曲线2.png"),"alt":"此图片暂时无法显示"}})]),_c('div',{staticClass:"ninety_right"})])
}]

export { render, staticRenderFns }